window.__WWAI__ = window.__WWAI__ || {};
    
// Environment + Mode Config
// Use metafield-based subscription in sandbox/local
window.__WWAI__.useMockSubscription = false;

// Options: "local" | "sandbox" | "prod"
window.__WWAI__.deployMode = "prod";

// Enables dev/debugger mode, values are dev, prod
window.__WWAI__.MODE = "prod";

// Controls Liquid-product rendering
window.__WWAI__.RENDER_WITH_LIQUID = true;

// Which connector to use for hydration
window.__WWAI__.CONNECTOR_TYPE = "shopify";

// Enable logging for grid height debugging
window.__WWAI__.heightEqualizeLogging = true;

// Currency Config
// Active currency from Shopify
window.__WWAI__.CURRENCY = Shopify.currency.active;

// Currency conversion factor
window.__WWAI__.CURRENCY_FACTOR = 0.01;

// Product mapping object
window.__WWAI__.JS_PRODUCT_MAPPING_OBJECT = {};

// Product group config
window.__WWAI__.WWAI_PRODUCT_GROUP_CONFIG = {
  "r_co_badlands_pdp_NGeG6b": {
    "defaults": {
      "pricingConfig": {
        "discountPercent": 0,
        "subscriptionDiscountPercent": 0,
        "defaultSubscriptionOption": null,
        "useVariantCompareAtPriceForSubscription": true,
        "discountCodeToApply": [],
        "roundDiscount": true,
        "addOffSuffixToDiscount": false
      },
      "uxConfig": {
        "variantOptionRemovePrefix": "Every",
        "defaultPurchaseType": "subscription",
        "variantUXConfig": {
          "hideSingleLengthVariants": false,
          "onlyShowVariantsWithLabelContains": null,
          "refreshUxOnVariantChange": true
        },
        "preAddToCartFlowConfig": {
          "journeyType": "overlay",
          "overlayContents": [],
          "postSelectionAction": "na",
          "postSelectionActionParams": {
            "custom_url": null,
            "redirect_variant_options": null
          }
        }
      },
      "flowConfig": {
        "destination": "checkout",
        "loader": "add-to-cart-submit-button",
        "showSuccessNotification": false,
        "showErrorNotification": false,
        "sideCartLabel": "rco",
        "successNotificationMessage": "✅ Added to cart!",
        "errorNotificationMessage": "Oops, couldn't add item.",
        "notificationOptions": {
          "backgroundColor": "#E8DDFA",
          "textColor": "#000000",
          "borderColor": "transparent",
          "fontFamily": "sans-serif"
        }
      }
    },
    "badlands-dry-shampoo-paste-wwai-sticky": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "badlands-dry-shampoo-paste-wwai",
        "defaultVariantOption1": "2.2 OZ",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "badlands-dry-shampoo-paste-wwai",
        "allOptions": {
          "option1": "2.2 OZ",
          "option2": "",
          "option3": ""
        }
      }
    },
    "badlands-dry-shampoo-paste-wwai": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "2-2-oz",
        "defaultVariantOption1": "__wwai_first__",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "2-2-oz",
        "allOptions": {
          "option1": "__wwai_first__",
          "option2": "",
          "option3": ""
        }
      }
    },
    "badlands-dry-shampoo-paste-2-pack": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "badlands-dry-shampoo-paste-2-pack",
        "defaultVariantOption1": "2-pack",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "badlands-dry-shampoo-paste-2-pack",
        "allOptions": {
          "option1": "2-pack",
          "option2": "",
          "option3": ""
        }
      }
    },
    "badlands-dry-shampoo-paste-3-pack": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "badlands-dry-shampoo-paste-3-pack",
        "defaultVariantOption1": "3-pack",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "badlands-dry-shampoo-paste-3-pack",
        "allOptions": {
          "option1": "3-pack",
          "option2": "",
          "option3": ""
        }
      }
    }
  },
  "r_co_badlands_products_aimAGq": {
    "defaults": {
      "pricingConfig": {
        "discountPercent": 0,
        "subscriptionDiscountPercent": 0,
        "defaultSubscriptionOption": null,
        "useVariantCompareAtPriceForSubscription": true,
        "discountCodeToApply": [],
        "roundDiscount": true,
        "addOffSuffixToDiscount": false
      },
      "uxConfig": {
        "variantOptionRemovePrefix": "Every",
        "defaultPurchaseType": "subscription",
        "variantUXConfig": {
          "hideSingleLengthVariants": false,
          "onlyShowVariantsWithLabelContains": null,
          "refreshUxOnVariantChange": true
        },
        "preAddToCartFlowConfig": {
          "journeyType": "overlay",
          "overlayContents": [],
          "postSelectionAction": "na",
          "postSelectionActionParams": {
            "custom_url": null,
            "redirect_variant_options": null
          }
        }
      },
      "flowConfig": {
        "destination": "checkout",
        "loader": "add-to-cart-submit-button",
        "showSuccessNotification": false,
        "showErrorNotification": false,
        "sideCartLabel": "rco",
        "successNotificationMessage": "✅ Added to cart!",
        "errorNotificationMessage": "Oops, couldn't add item.",
        "notificationOptions": {
          "backgroundColor": "#E8DDFA",
          "textColor": "#000000",
          "borderColor": "transparent",
          "fontFamily": "sans-serif"
        }
      }
    },
    "dart-pomade-stick-wwai": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "dart-pomade-stick-wwai",
        "defaultVariantOption1": "0.5 OZ",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "dart-pomade-stick-wwai",
        "allOptions": {
          "option1": "0.5 OZ",
          "option2": "",
          "option3": ""
        }
      }
    },
    "vapor-lotion-to-powder-dry-shampoo": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "vapor-lotion-to-powder-dry-shampoo",
        "defaultVariantOption1": "3 OZ",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "vapor-lotion-to-powder-dry-shampoo",
        "allOptions": {
          "option1": "3 OZ",
          "option2": "",
          "option3": ""
        }
      }
    },
    "outer-space-flexible-hairspray-wwai": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "outer-space-flexible-hairspray-wwai",
        "defaultVariantOption1": "9.5 OZ",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "outer-space-flexible-hairspray-wwai",
        "allOptions": {
          "option1": "9.5 OZ",
          "option2": "",
          "option3": ""
        }
      }
    }
  }
};

// Variant overrides
window.__WWAI__.WWAI_PRODUCT_VARIANT_OVERRIDES = {
  "r_co_badlands_pdp_NGeG6b": {
    "badlands-dry-shampoo-paste-wwai-sticky": {
      "badlands-dry-shampoo-paste-wwai": {
        "2.2 OZ": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "badlands-dry-shampoo-paste-wwai": {
      "2-2-oz": {
        "__wwai_first__": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "badlands-dry-shampoo-paste-2-pack": {
      "badlands-dry-shampoo-paste-2-pack": {
        "2-pack": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "badlands-dry-shampoo-paste-3-pack": {
      "badlands-dry-shampoo-paste-3-pack": {
        "3-pack": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    }
  },
  "r_co_badlands_products_aimAGq": {
    "dart-pomade-stick-wwai": {
      "dart-pomade-stick-wwai": {
        "0.5 OZ": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "vapor-lotion-to-powder-dry-shampoo": {
      "vapor-lotion-to-powder-dry-shampoo": {
        "3 OZ": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "outer-space-flexible-hairspray-wwai": {
      "outer-space-flexible-hairspray-wwai": {
        "9.5 OZ": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    }
  }
};

// Labeled images
window.__WWAI__.WWAI_LABELED_IMAGES = {};

// Action buttons
window.__WWAI__.WWAI_ACTION_BUTTONS = {
  "//div[@id=\"shopify-section-template--24912978641213__r_co_badlands_reasons_HxpJtQ\"]//div[1]/div[1]/div[1]/div[1]/div[2]/div[1]/div[2]/a[1]": {
    "actionType": "scroll-to",
    "value": "shopify-section-template--24912978641213__r_co_badlands_pdp_NGeG6b"
  },
  "//div[@id=\"shopify-section-template--24912978641213__r_co_badlands_reasons_HxpJtQ\"]//div[1]/div[1]/div[1]/div[1]/div[2]/div[2]/div[2]/a[1]": {
    "actionType": "scroll-to",
    "value": "shopify-section-template--24912978641213__r_co_badlands_pdp_NGeG6b"
  },
  "//div[@id=\"shopify-section-template--24912978641213__r_co_badlands_reasons_HxpJtQ\"]//div[1]/div[1]/div[1]/div[1]/div[2]/div[3]/div[2]/a[1]": {
    "actionType": "scroll-to",
    "value": "shopify-section-template--24912978641213__r_co_badlands_pdp_NGeG6b"
  }
};